// Espelha lib/permissions.ts: nomes de feature num só lugar, sem string mágica
// espalhada pelos componentes. A chave é a mesma que /auth/me devolve.
export const Features = {
  PdfViewer: 'pdfViewer',
} as const
